/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Invoice controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetInvoiceByIdResponse, UpdateInvoiceRequest, RunDailyInvoicingResponse, GetOutgoingInvoicesResponse, GetLastNumberedInvoiceDateResponse, InvoiceStateId, PaymentMethod, GetInvoicesResponse, CreateInvoiceRequest, CreateInvoiceResponse, GetInvoiceAccountingOperationsResponse, GetCustomerInvoicingPreviewResponse } from "../models";

@Injectable({ providedIn: "root" })
export class InvoiceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getInvoiceById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetInvoiceByIdResponse>;
    getInvoiceById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetInvoiceByIdResponse>>;
    getInvoiceById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetInvoiceByIdResponse>>;
    getInvoiceById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateInvoice(id: number, updateInvoiceRequest: UpdateInvoiceRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateInvoice(id: number, updateInvoiceRequest: UpdateInvoiceRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateInvoice(id: number, updateInvoiceRequest: UpdateInvoiceRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateInvoice(id: number, updateInvoiceRequest: UpdateInvoiceRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateInvoiceRequest, requestOptions);
    }

    deleteInvoice(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteInvoice(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteInvoice(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteInvoice(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    sendInvoice(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, isProForma: boolean, attachments?: (Array<Blob> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    sendInvoice(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, isProForma: boolean, attachments?: (Array<Blob> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    sendInvoice(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, isProForma: boolean, attachments?: (Array<Blob> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    sendInvoice(id: number, to: Array<string>, cc: Array<string>, bcc: Array<string>, object: string, content: string, isProForma: boolean, attachments?: (Array<Blob> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/${id}/send`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Remove Content-Type for multipart (browser will set it with boundary)
        headers = headers.delete('Content-Type');

        const formData = new FormData();
        if (to !== undefined && Array.isArray(to)) {
            to.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('to', String(item));
                }
            });
        }
        if (cc !== undefined && Array.isArray(cc)) {
            cc.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('cc', String(item));
                }
            });
        }
        if (bcc !== undefined && Array.isArray(bcc)) {
            bcc.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('bcc', String(item));
                }
            });
        }
        if (object !== undefined) {
            formData.append('object', String(object));
        }
        if (content !== undefined) {
            formData.append('content', String(content));
        }
        if (isProForma !== undefined) {
            formData.append('isProForma', String(isProForma));
        }
        if (attachments !== undefined && Array.isArray(attachments)) {
            attachments.forEach((item) => {
                if (item !== undefined && item !== null) {
                    formData.append('attachments', item);
                }
            });
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, formData, requestOptions);
    }

    runDailyInvoicing(observe?: 'body', options?: RequestOptions<'json'>): Observable<RunDailyInvoicingResponse>;
    runDailyInvoicing(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<RunDailyInvoicingResponse>>;
    runDailyInvoicing(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<RunDailyInvoicingResponse>>;
    runDailyInvoicing(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/run-daily-invoicing`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, null, requestOptions);
    }

    getOutgoingInvoices(stardDate: Date, endDate: Date, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetOutgoingInvoicesResponse>;
    getOutgoingInvoices(stardDate: Date, endDate: Date, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetOutgoingInvoicesResponse>>;
    getOutgoingInvoices(stardDate: Date, endDate: Date, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetOutgoingInvoicesResponse>>;
    getOutgoingInvoices(stardDate: Date, endDate: Date, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/Outgoing`;

        let params = new HttpParams();
        if (stardDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, stardDate, 'stardDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getLastNumberedInvoiceDate(legalEntityId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetLastNumberedInvoiceDateResponse>;
    getLastNumberedInvoiceDate(legalEntityId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetLastNumberedInvoiceDateResponse>>;
    getLastNumberedInvoiceDate(legalEntityId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetLastNumberedInvoiceDateResponse>>;
    getLastNumberedInvoiceDate(legalEntityId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/last-numbered-date`;

        let params = new HttpParams();
        if (legalEntityId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, legalEntityId, 'legalEntityId');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getInvoices(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<InvoiceStateId>, legalEntityIds: Array<number>, paymentMethods: Array<PaymentMethod>, search?: string | null, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetInvoicesResponse>;
    getInvoices(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<InvoiceStateId>, legalEntityIds: Array<number>, paymentMethods: Array<PaymentMethod>, search?: string | null, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetInvoicesResponse>>;
    getInvoices(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<InvoiceStateId>, legalEntityIds: Array<number>, paymentMethods: Array<PaymentMethod>, search?: string | null, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetInvoicesResponse>>;
    getInvoices(startDate: Date, endDate: Date, customerIds: Array<number>, stateNames: Array<InvoiceStateId>, legalEntityIds: Array<number>, paymentMethods: Array<PaymentMethod>, search?: string | null, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice`;

        let params = new HttpParams();
        if (startDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, startDate, 'startDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }
        if (search != null) {
            params = HttpParamsBuilder.addToHttpParams(params, search, 'search');
        }
        if (customerIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, customerIds, 'customerIds');
        }
        if (stateNames != null) {
            params = HttpParamsBuilder.addToHttpParams(params, stateNames, 'stateNames');
        }
        if (legalEntityIds != null) {
            params = HttpParamsBuilder.addToHttpParams(params, legalEntityIds, 'legalEntityIds');
        }
        if (paymentMethods != null) {
            params = HttpParamsBuilder.addToHttpParams(params, paymentMethods, 'paymentMethods');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createInvoice(createInvoiceRequest: CreateInvoiceRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateInvoiceResponse>;
    createInvoice(createInvoiceRequest: CreateInvoiceRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateInvoiceResponse>>;
    createInvoice(createInvoiceRequest: CreateInvoiceRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateInvoiceResponse>>;
    createInvoice(createInvoiceRequest: CreateInvoiceRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createInvoiceRequest, requestOptions);
    }

    getInvoicesPeppolFile(uuids: Array<string>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    getInvoicesPeppolFile(uuids: Array<string>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    getInvoicesPeppolFile(uuids: Array<string>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    getInvoicesPeppolFile(uuids: Array<string>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/PeppolFile`;

        let params = new HttpParams();
        if (uuids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, uuids, 'uuids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getInvoicesAttachments(uuids: Array<string>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    getInvoicesAttachments(uuids: Array<string>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    getInvoicesAttachments(uuids: Array<string>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    getInvoicesAttachments(uuids: Array<string>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/Attachments`;

        let params = new HttpParams();
        if (uuids != null) {
            params = HttpParamsBuilder.addToHttpParams(params, uuids, 'uuids');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getInvoicePdf(id: number, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    getInvoicePdf(id: number, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    getInvoicePdf(id: number, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    getInvoicePdf(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/${id}/Pdf`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            responseType: 'blob' as 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getInvoiceAccountingOperations(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetInvoiceAccountingOperationsResponse>;
    getInvoiceAccountingOperations(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetInvoiceAccountingOperationsResponse>>;
    getInvoiceAccountingOperations(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetInvoiceAccountingOperationsResponse>>;
    getInvoiceAccountingOperations(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/${id}/AccountingOperations`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getIncomingInvoices(stardDate: Date, endDate: Date, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetInvoicesResponse>;
    getIncomingInvoices(stardDate: Date, endDate: Date, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetInvoicesResponse>>;
    getIncomingInvoices(stardDate: Date, endDate: Date, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetInvoicesResponse>>;
    getIncomingInvoices(stardDate: Date, endDate: Date, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/Incoming`;

        let params = new HttpParams();
        if (stardDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, stardDate, 'stardDate');
        }
        if (endDate != null) {
            params = HttpParamsBuilder.addToHttpParams(params, endDate, 'endDate');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getCustomerInvoicingPreview(customerId: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetCustomerInvoicingPreviewResponse>;
    getCustomerInvoicingPreview(customerId: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetCustomerInvoicingPreviewResponse>>;
    getCustomerInvoicingPreview(customerId: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetCustomerInvoicingPreviewResponse>>;
    getCustomerInvoicingPreview(customerId: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Invoice/invoicing-preview`;

        let params = new HttpParams();
        if (customerId != null) {
            params = HttpParamsBuilder.addToHttpParams(params, customerId, 'customerId');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
